// extracted by mini-css-extract-plugin
export var dropdown = "_ge-0";
export var imagePlaceholder = "_ge-2";
export var imageWrapper = "_ge-3";
export var productImage = "_ge-1";
export var truncateContainer = "_ge-4";
export var truncateText = "_ge-5";